import { useNavigate, useSearchParams } from "react-router-dom";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import moment from "moment";
import { readPostApi } from "../../../../api/support/board";
import { ReadPostApiProps } from "../../../../types/support/board";
import { useUser } from "../../../../util/userContext/UserContext";

/**
 * 게시판 목록 hook
 * @returns
 */
export default function useReadPost() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { user } = useUser();

    const buildQuery = (searchParam: ReadPostApiProps) => {
        return `?keyword=${searchParam.keyword}&pageNo=${searchParam.pageNo}&limit=${searchParam.limit}&startAt=${searchParam.startAt}&endAt=${searchParam.endAt}`;
    }

    const queryStringParam: ReadPostApiProps = {
        keyword: searchParams?.get("keyword") || '',
        pageNo: Number(searchParams?.get("pageNo")) || 1,
        limit: 10,
        startAt: searchParams?.get("startAt") || moment().startOf('year').format('YYYY-MM-DD'),  // 1월 1일로 변경
        endAt: searchParams?.get("endAt") || moment().format('YYYY-MM-DD'),
        inOutFlag: user?.authority.boardWriteYn === 'Y' ? '0' : '1',
        customerId: user?.userId
    }
    const [searchParam, setSearchParam] = useState(queryStringParam)

    const res = useQuery({
        queryKey: ["readPostApi", queryStringParam],
        queryFn: async () => await readPostApi(queryStringParam),
        // staleTime: 6000 * 10,
        select: (res) => res?.result
    });

    const search = () => {
        navigate(buildQuery(searchParam));
    }

    return { res, searchParam, setSearchParam, search }
}